import { PhoneMultiFactorInfo } from 'firebase/auth';
import * as React from 'react';
import { SelectionCard } from '../../../../shared/SelectionCard';

export interface IPhoneHintProps {
  hint: PhoneMultiFactorInfo;
  onClick: (value: PhoneMultiFactorInfo) => void;
  selected: boolean;
  animationDelay?: number;
}

export const PhoneHint = React.memo(
  (props: IPhoneHintProps): React.ReactElement => {
    const handleClick = React.useCallback((): void => {
      props.onClick(props.hint);
    }, [props.onClick, props.hint]);

    return (
      <SelectionCard
        selected={props.selected}
        onClick={handleClick}
        icon='phone_android'
        title={props.hint.phoneNumber ?? 'Phone'}
        description='Verify via SMS'
        animationDelay={props.animationDelay}
      />
    );
  },
  (
    prevProps: Readonly<IPhoneHintProps>,
    nextProps: Readonly<IPhoneHintProps>
  ): boolean => {
    return (
      prevProps.selected === nextProps.selected &&
      prevProps.hint.uid === nextProps.hint.uid &&
      prevProps.onClick === nextProps.onClick &&
      prevProps.animationDelay === nextProps.animationDelay
    );
  }
);

PhoneHint.displayName = 'PhoneHint';
